import { API_ROUTES } from '@/api/apiRoutes';
import { safeAxios } from '@/services/safeAxios';

export interface FigmaNodeConnectionRecord {
  figmaNodeId: string;
  figmaFileKey: string;
  figmaFrameId: string;
}

/** POST /v1/workflows/{workflowId}/figma-node-connections — records the connected-frame quad. */
export async function createFigmaNodeConnection(
  workflowId: string,
  connection: FigmaNodeConnectionRecord,
): Promise<void> {
  await safeAxios.post(API_ROUTES.workflows.figmaNodeConnections({ workflowId }), connection);
}

/** DELETE /v1/workflows/{workflowId}/figma-node-connections — removes the connected-frame row. */
export async function deleteFigmaNodeConnection(
  workflowId: string,
  frame: { figmaFileKey: string; figmaFrameId: string },
): Promise<void> {
  await safeAxios.delete(API_ROUTES.workflows.figmaNodeConnections({ workflowId }), { params: frame });
}
